import React from 'react'

export default function Error() {
    return <span>Error in fetching data ...</span>
}
